import * as styles from './styles/styles.module.scss';
import Logo from '../../../../../assets/images/partners-logos/1_Percent_Logo_@2x.png';
import { FormattedMessage } from '@alltrails/shared/react-intl';

const OnePercentForThePlanet = () => {
  return (
    <section className={styles.container}>
      <div>
        <img src={Logo} className={styles.logo} alt="1% for the Planet" />
        <div className={styles.subText}>
          <FormattedMessage defaultMessage="As a proud member of 1% for the Planet, we give 1% of our annual sales to nonprofit organizations focusing on protecting the wild places we cherish and creating positive change for a healthier planet." />
        </div>
      </div>
    </section>
  );
};

export default OnePercentForThePlanet;
